

export class GuidanceNote {
  questionId: string;
  text: string;
  title: string;
  id: number;
  questionnaireId: string;
  
  constructor() {
    this.questionId = '';
    this.text = '';
    this.title = '';
    this.questionnaireId = '';
  }
}
